import gql from 'graphql-tag'
import { TypedDocumentNode } from '@apollo/client'
import { LoginResponse, Variables } from './types'

export const LOGIN_MUTATION: TypedDocumentNode<LoginResponse, Variables> = gql`
  mutation login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      ... on LoginSuccess {
        __typename
        accessToken
        refreshToken
        locationToken
      }

      ... on InvalidCredentialsError {
        __typename
      }
    }
  }
`
